<div class="error-notification" *ngIf="error" [ngClass]="getColor()">
  <div class="notification-content">
    <i class="material-icons">{{getIcon()}}</i>
    <div class="message">
      <span class="main-message">{{error.message}}</span>
      <span class="details" *ngIf="error.details">{{error.details}}</span>
    </div>
    <button class="close-button" (click)="clearError()">
      <i class="material-icons">close</i>
    </button>
  </div>
</div> 